import { modulePermissionsSelectors } from '@va/dashboard/selectors/core';
import { isSidebarOpen } from '@va/dashboard/selectors/ui';
import { AppVersion, Sidebar } from '@va/dashboard/shared/feature-sidebar';
import { navigationActions } from '@va/dashboard/slices';
import { isAccountSettingsPageSelected } from '@va/standalone/shared/helpers';
import { WebsiteSelector } from 'aaas/components/website-selector/WebsiteSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useNavigationTabs } from '../helpers/menu-navigation-tabs';

export const SidebarWrapper = () => {
  const isOpen = useSelector(isSidebarOpen);
  const dispatch = useDispatch();

  const isEnabled = useSelector(modulePermissionsSelectors.isModuleEnabled);
  const { pathname } = useLocation();

  const navigationTabs = useNavigationTabs(isEnabled);

  if (isAccountSettingsPageSelected(pathname)) return null;

  return (
    <Sidebar
      websiteSelector={
        <div className='lg:hidden w-full z-30 px-2 pt-2'>
          <WebsiteSelector />
        </div>
      }
      sidebarItems={navigationTabs as any}
      isSidebarExpand={isOpen}
      onToggleSidebar={() => {
        dispatch(navigationActions.toggleSidebar());
      }}
      setIsSidebarExpanded={(value) => {
        dispatch(navigationActions.setIsSidebarOpen(value));
      }}
      footer={() => (
        <div className='flex flex-col items-center gap-3 justify-end h-full pb-3'>
          <AppVersion />
        </div>
      )}
    />
  );
};
